import { ACCOUNT_CARD_ADD } from 'client/redux/account/constants';
import * as actionCreators from 'client/redux/account/actionCreators';

export const accountCardAdd = json => dispatch => {
  return dispatch(actionCreators.accountCardAdd(ACCOUNT_CARD_ADD, json));
};
